import React from 'react';
import '../styles/Ticker.css';

/**
 * Placement tape: recent results printed like market data.
 * Every entry is drawn from the case record on this page.
 */
const ENTRIES = [
  'BULGE BRACKET S&T · SPRING WEEK ▲ OFFER',
  'FIRST-YEAR → BB TRADING FLOOR ▲ PLACED',
  'MULTI-STRAT HF · FIXED INCOME RV ▲ OFFER',
  'JPM · SUMMER ANALYST · IBD ▲ OFFER',
  'TOP-THREE CONSULTANCY · FINAL ROUND ▲ OFFER',
  'NON-TARGET → JPM ▲ PLACED'
];

const Ticker: React.FC = () => {
  const tape = ENTRIES.join('  ///  ');

  return (
    <div className="ticker" role="marquee" aria-label="Recent placements">
      <div className="ticker-track">
        <span className="ticker-tape">{tape}&ensp;///&ensp;</span>
        <span className="ticker-tape" aria-hidden="true">
          {tape}&ensp;///&ensp;
        </span>
      </div>
    </div>
  );
};

export default Ticker;
